<template>
  <v-form ref="form">
    <v-container>
      <v-row class="contentRow">
        <v-col cols="12" class="mb-3">
          <h1>Locate</h1>
          <p class="mt-10">
            You can find data submitted to the blockchain using this page.
            <br />Please prepare your data unit hash, which you should have received when submitting the data.
            <br />
            <br />If you would like to find a specific block, please enter the block hash, or height, in the bottom field.
          </p>
        </v-col>
      </v-row>
      <v-row class="contentRow" v-if="!!dataunitResult">
        <v-col cols="12">
          <h2 class="text-center mb-3">Data Unit Status</h2>
          <p class>
            <b>Data Unit:&nbsp;</b>
            {{dataunitResult.duid}}
            <br />
            <b>Status:&nbsp;</b>
            <span
              v-if="typeof dataunitResult.block === 'string' || typeof dataunitResult.block === 'number'"
              class="success--text"
            >Found in Blockchain</span>
            <span v-else-if="dataunitResult.block == false" class="error--text">Not Found</span>
            <span v-else class="warning--text">Not in Blockchain</span>
            <br />
            <b>Block #:&nbsp;</b>
            <span v-if="typeof dataunitResult.block === 'string' || typeof dataunitResult.block === 'number'">{{dataunitResult.block}}</span>
            <span v-else class="warning--text">N/A</span>
            <br />
          </p>
          <v-alert type="error" v-if="dataunitResult.block == false">
            The data unit was not found on the node, or in the blockchain.
            <br />Make sure the DU Hash is correct, and try again. If the error persists, you need to re-submit the data unit.
          </v-alert>
          <v-alert type="warning" v-if="dataunitResult.block == true">
            The data unit was found on the node, but not in the blockchain.
            <br />Please allow a few minutes for the nodes to include the data unit in a block.
          </v-alert>
          <v-alert type="success" v-if="typeof dataunitResult.block === 'string' || typeof dataunitResult.block === 'number'">
            The data unit was found in the blockchain.
            <br />Press the button below to see the full block.
          </v-alert>
          <v-btn class color="secondary" :to="'/blocks/'+dataunitResult.block" v-if="typeof dataunitResult.block === 'string' || typeof dataunitResult.block === 'number'">
            SEE BLOCK
            <v-icon small class="ml-3">fas fa-external-link-alt</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row class="contentRow">
        <v-col cols="12">
          <h2 class="text-center mb-3">Find your data unit</h2>
          <v-text-field
            class="text-center"
            v-model="dataunitInput"
            label="Input Data Unit hash here"
            outlined
          />
          <v-btn :disabled="dataunitInput == ''" class="justify-center primary" @click="finddu">
            Find Data Unit
            <v-icon class="ml-4">fas fa-search</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="12">
          <h2 class="text-center mb-3">Find your block</h2>
          <v-text-field
            class="text-center"
            v-model="blockInput"
            label="Input Block hash here"
            outlined
          />
          <v-btn :disabled="blockInput == ''" class="justify-center primary" @click="findblock">
            Find block
            <v-icon small class="ml-4">fas fa-external-link-alt</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <error-dialog :error="error" />
    <v-dialog v-model="loading" hide-overlay persistent width="300">
      <v-card color="secondary" dark>
        <v-card-text class="text-center mx-auto">
          <ssc-loader />
          <p class="pt-3 white--text">loading data unit status...</p>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-form>
</template>
<script>
import API from "../api/api"

export default {
  name: "SingleBlock",

  data() {
    return {
      dataunitResult: null,
      error: null,
      loading: false,
      dataunitInput: "",
      blockInput: ""
    };
  },
  methods: {
    finddu() {
      let dataunitID = ("" + (this.dataunitInput || "")).trim();
      if (!dataunitID) {
        this.error = "Please enter a data unit hash.";
        return;
      }
      this.loading = true;

      API
        .get("/api/dataunits/" + encodeURIComponent(dataunitID))
        .then(response => {
          this.loading = false;
          if (response.data.error.length > 0) {
            this.error = response.data.error[0].message;
            return;
          }
          if (response.data.data.length < 1) {
            this.error = "The server did not return any data.";
            return;
          }
          this.dataunitResult = {
            duid: dataunitID,
            block: response.data.data[0]
          };
        })
        .catch(reason => {
          this.error = reason; //reason;
          console.log("Load error: " + reason);
          this.loading = false;
        });
      //this.goToBlock();
    },
    findblock() {
      this.$router.push({ path: `/blocks/${this.blockInput}` });
    }
  }
};
</script>